import React from 'react';
import GuestLayout from '../components/GuestLayout';
import BookingPageNew from './BookingPageNew';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

/**
 * GuestBookingPage: For /guest/booking route
 * - Only accessible to guests
 * - Renders guest booking UI (BookingPageNew)
 * - All data must be scoped to current guest
 */
export default function GuestBookingPage() {
  const { userProfile } = useAuth();

  if (!userProfile || userProfile.role !== 'guest') {
    // Redirect non-guests to their dashboard
    return <Navigate to={userProfile ? `/${userProfile.role}` : '/login'} replace />;
  }

  return (
    <GuestLayout>
      <BookingPageNew />
    </GuestLayout>
  );
}
